import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Sticky from 'Components/Sticky';


import { ReactComponent as BackIcon } from 'Icons/back.svg';
import {  CHALLENGE_PRICE, GET_SEEKER_TRANSPORTER_BIDS, CLEAR_SEEKER_TRANSPORTER_BIDS } from 'Constants/actionConstants';
import ChallengePriceTooltip from 'Components/ChallengePriceTooltip';
import ClickOutside from 'Components/ClickOutside';
import TransporterBids from 'Components/TransportersTable/TransporterBids';
import ActionLoader from 'Components/ActionLoader';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { SEND_LOI } from 'Constants/actionConstants';

class TransporterDetail extends Component {
    state = {
        isChallengePriceShown : false,
        isLoiPopupShown: false,
        selectedBids: []
    }
    showChallengePrice = ()=> {
        this.setState({
            isChallengePriceShown: true
        })
    }
    hideChallengePrice = ()=> {
        this.setState({
            isChallengePriceShown: false
        });
    }
    showLoiPopup = ()=> {
        this.setState({
            isLoiPopupShown: true
        })
    }
    hideLoiPoup = ()=> {
        this.setState({
            isLoiPopupShown: false
        });
    }
    sendChallengePrice = (price)=> {
        const { dispatch, match } = this.props;
        const data = {
            rfq_id: match.params.rfqId,
            price_list: this.state.selectedBids.map((bid)=> {
                return {
                    trip_id: bid.id,
                    challenge_price: Number(price),
                    transporter_id: match.params.transporterId
                }
            })
        }
        dispatch({
            type: CHALLENGE_PRICE,
            data,
            onSuccess: this.getTransporterBids

        });
        this.setState({
            isChallengePriceShown: false
        })
    }
    sendLoi = ()=> {
        this.setState({
            isLoiPopupShown: false
        });
        const { dispatch, match } = this.props;
        const data = {
            rfq_id: match.params.rfqId,
            loi_list: this.state.selectedBids.map((bid)=> {
                return {
                    trip_id: bid.id,
                    transporter_id: match.params.transporterId
                }
            })
        }
        dispatch({
            type: SEND_LOI,
            data,
            onSuccess: this.getTransporterBids
        })
    }
    setBids = (selectedBids)=> {
        this.setState({
            selectedBids
        });
    }
    getTransporterBids = (filters={})=> {
        const { dispatch, match } = this.props;
        dispatch({
            type: GET_SEEKER_TRANSPORTER_BIDS,
            params: {
                rfqId: match.params.rfqId,
                transporterId: match.params.transporterId,
                ...filters
            },
            onSuccess: this.setTransporterBidsTimer
        })
    }
    setTransporterBidsTimer = ()=> {
        if(this.unmounted) {return};
        if(this.transporterBidsTimer) {
            clearTimeout(this.transporterBidsTimer);
        }
        this.transporterBidsTimer = setTimeout(()=> {
            this.getTransporterBids();
        }, 10000);
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.getTransporterBids();
        dispatch({
            type: CLEAR_SEEKER_TRANSPORTER_BIDS
        })
    }
    fetchTrips = (filters)=> {
        const { dispatch } = this.props;
        dispatch({
            type: CLEAR_SEEKER_TRANSPORTER_BIDS
        })
        this.getTransporterBids(filters);
    }
    componentWillUnmount = ()=> {
        this.unmounted = true;
        clearTimeout(this.transporterBidsTimer)
    }
    render() {
        const { 
            trips, 
            isTransporterBidsLoading, 
            match, 
            transporter, 
            paymentCycles, 
            pricingBasis,
            vehicleTypes,
            vehicleBodyTypes
        } = this.props;
        return (
            <div>
                {this.state.isLoiPopupShown && 
                    <ConfirmationPopup 
                        text={'Are you sure you want to send the LOI'}
                        onCancel = {this.hideLoiPoup}
                        onConfirm = {this.sendLoi}
                    />}
                {isTransporterBidsLoading && (trips || []).length === 0 && <ActionLoader fixed={true}/>}
                <Sticky>   
                    <Link to={"/seeker/bids/" + match.params.rfqId} className="ht-60 flex flex-middle pl-40">
                        <BackIcon className="mr-10 fill-theme curP"/>
                        <div className="header-dark-color fs-16 fBold">Back to RFQ</div>
                    </Link>
                    <TransporterBids vehicleBodyTypes={vehicleBodyTypes} vehicleTypes={vehicleTypes} paymentCycles={paymentCycles} pricingBasis={pricingBasis} isTransporterBidsLoading={isTransporterBidsLoading} fetchTrips={this.fetchTrips} transporter={transporter} setBids={this.setBids} trips={trips} /> 
                    {trips && trips.length > 0 && trips[0].biddingDetails.to < new Date().getTime() && <div className="pf col-1 b-0 ht-60 flex flex-middle flex-right box-shadow bg-white">
                        {this.state.isChallengePriceShown && <ClickOutside handleClickOutside={this.hideChallengePrice}><div className="pa b-70 mt--2 r-140"><ChallengePriceTooltip submitPrice={this.sendChallengePrice}/></div></ClickOutside>}
                        <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.showChallengePrice}>Challenge Price</button>
                        {/* <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={this.showLoiPopup}>Send LOI</button> */}
                    </div>}
                </Sticky>
            </div>
        )
    }
}


const mapStateToProps = ({contracting, constants}) => {
    return {
        trips: contracting.transporterBids.data || [],
        isTransporterBidsLoading: contracting.transporterBids.dataLoading,
        transporter: contracting.transporterBids.transporter || {},

        paymentCycles: constants.paymentCycles || [],
        pricingBasis: constants.pricingBasis || [],
        vehicleTypes: constants.vehicleTypes || [],
        vehicleBodyTypes: constants.vehicleBodyTypes || [],
    }
};


export default connect(mapStateToProps)(TransporterDetail);